module.exports = __webpack_public_path__ + "static/media/flag_white.6be2712d.svg";